import {
  ItemDetailsDto,
  ItemDetailsSidebarSectionResp,
} from '@marketplace-web/item-page/item-page-data'

import { ItemPageItemStatusPluginModel } from './types'

export const getItemPageItemStatusPluginModel = (
  itemDto: ItemDetailsDto,
): ItemPageItemStatusPluginModel => ({
  userId: itemDto.user.id,
  reservation: itemDto.reservation,
  isDraft: itemDto.is_draft,
  isReserved: itemDto.is_reserved,
  isHidden: itemDto.is_hidden,
  isClosed: itemDto.is_closed,
  itemClosingAction: itemDto.item_closing_action,
  statsVisible: itemDto.stats_visible,
  itemAlert: itemDto.item_alert,
  isProcessing: itemDto.is_processing,
  promoted: itemDto.promoted,
})

export const getServerItemPageItemStatusPluginModel = (
  sidebarDto: ItemDetailsSidebarSectionResp,
): ItemPageItemStatusPluginModel => ({
  userId: sidebarDto.seller_id,
  reservation: sidebarDto.reservation,
  isDraft: sidebarDto.is_draft,
  isReserved: sidebarDto.is_reserved,
  isHidden: sidebarDto.is_hidden,
  isClosed: sidebarDto.is_closed,
  itemClosingAction: sidebarDto.item_closing_action,
  statsVisible: sidebarDto.stats_visible,
  itemAlert: sidebarDto.item_alert,
  isProcessing: sidebarDto.is_processing,
  promoted: sidebarDto.promoted,
})
